import React from 'react';
import { Editor, EditorTools } from '@progress/kendo-react-editor';

const {
    Bold,
    Italic,
    Underline,
    AlignLeft,
    AlignRight,
    AlignCenter,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    Link,
    Unlink,
    ViewHtml,
    FormatBlock
    } = EditorTools;

const WiziwigField = ({ label, name, value, onChange, placeholder, setValue, defaultValue, explanation, rules, error, watch }) => {
    return (
        <div className='mb-3 flex w-full'>
            <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label} {rules && <span className='text-red'>*</span>}</label>
            <div className='flex flex-col w-full max-w-xs'>
            <Editor
                tools={[
                    [Bold, Italic, Underline],
                    [Undo, Redo],
                    [Link, Unlink],
                    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                    [OrderedList, UnorderedList, Indent, Outdent],
                    [FormatBlock],
                    ViewHtml
                ]}
                contentStyle={{
                    height: 320,
                }}
                defaultContent={defaultValue}
                value={value}
                onChange={event => {
                    if (setValue) setValue(name, event.html);
                }}
            />
            {explanation && (
                <span className='text-brandDarkBlue text-xs text-gray-500 my-1 max-w-xs'>{explanation}</span>
            )}
            {error && <span className='text-red text-xs'>{error}</span>}
            </div>
        </div>
    )
};

export default WiziwigField;